import { render, staticRenderFns } from "./icon-picker.vue?vue&type=template&id=08174c90&scoped=true"
import script from "./icon-picker.vue?vue&type=script&lang=js"
export * from "./icon-picker.vue?vue&type=script&lang=js"
import style0 from "./icon-picker.vue?vue&type=style&index=0&id=08174c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08174c90",
  null
  
)

export default component.exports